import { render } from "./EditService.vue?vue&type=template&id=5484431a&scoped=true"
import script from "./EditService.vue?vue&type=script&lang=js"
export * from "./EditService.vue?vue&type=script&lang=js"

import "./EditService.vue?vue&type=style&index=0&id=5484431a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5484431a"]])

export default __exports__